/* ==========================================================================
   ZWANZE — cart-recovery.js
   Rattraper les paniers qui partent.

   TROIS MECANIQUES, DANS L'ORDRE OU ELLES SERVENT

   1. L'adresse. Sans email, un panier abandonne n'existe pas pour Shopify :
      il n'y a personne a relancer. Le champ du tiroir inscrit le visiteur
      comme contact ET colle son adresse sur le panier, ce qui la fait
      remonter sur la commande.

   2. Le titre de l'onglet. Quand le visiteur passe a autre chose, l'onglet
      change de titre. C'est le seul rappel qui traverse un changement
      d'onglet sans rien demander a personne : ni notification, ni cookie
      tiers, ni fenetre qui saute au visage.

   3. Le bandeau de retour. Au retour, apres un delai reglable, un bandeau
      discret rappelle ce qui reste dans le panier.

   CE QU'ON NE FAIT PAS, ET POURQUOI
   Pas de compte a rebours « votre panier expire dans 09:58 ». Shopify ne
   vide pas les paniers : ce serait un mensonge affiche en gros. Une marque
   qui ment sur une chose de cette taille se fait croire sur le reste a
   proportion.
   ========================================================================== */
(function () {
  'use strict';

  var Z = window.Zwanze;
  var root = document.querySelector('[data-cart-recovery]');
  if (!root) return;

  var KEY = 'zwanze:recovery';
  var titleOriginal = document.title;

  function state() {
    try { return JSON.parse(localStorage.getItem(KEY)) || {}; }
    catch (error) { return {}; }
  }
  function save(patch) {
    var next = state();
    for (var k in patch) next[k] = patch[k];
    try { localStorage.setItem(KEY, JSON.stringify(next)); } catch (error) { /* navigation privee */ }
  }
  function now() { return Date.now(); }

  function count() {
    var node = document.querySelector('[data-cart-count]');
    return node ? parseInt(node.textContent, 10) || 0 : 0;
  }

  /* ---------------------------------------------------------------------
     1. LE CHAMP EMAIL
     Deux envois : le formulaire client natif de Shopify (qui cree le
     contact et son consentement), puis l'attribut de panier (qui fait
     apparaitre l'adresse sur la commande et sur le panier abandonne).
     Le premier seul suffirait a inscrire ; le second seul ne suffirait
     jamais a joindre. Il faut les deux.
     --------------------------------------------------------------------- */
  document.addEventListener('submit', function (event) {
    var form = event.target.closest('.z-cartmail__form');
    if (!form) return;
    event.preventDefault();

    var box = form.closest('[data-cartmail]');
    var field = form.querySelector('input[type="email"]');
    if (!field || !field.value || !field.checkValidity()) {
      if (field) field.reportValidity();
      return;
    }
    var email = field.value.trim();
    if (box) box.setAttribute('data-busy', 'true');

    var data = new FormData(form);

    fetch(form.getAttribute('action') || '/contact', {
      method: 'POST',
      body: data,
      headers: { Accept: 'text/html' }
    }).then(function () {
      // L'attribut est pose meme si l'inscription echoue : une adresse sur
      // le panier reste utile au marchand, elle apparait sur la commande.
      return fetch((Z && Z.routes ? Z.routes.cartUpdate : '/cart/update') + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes: { 'Email de rappel': email } })
      });
    }).catch(function () {
      /* Reseau coupe : on affiche quand meme l'accuse, l'adresse est partie
         ou elle ne partira pas — reafficher le champ ferait retaper pour rien. */
    }).then(function () {
      if (!box) return;
      box.removeAttribute('data-busy');
      box.setAttribute('data-done', '');
      var done = box.querySelector('[data-cartmail-done]');
      if (Z && Z.announce && done) Z.announce(done.textContent.trim());
    });
  });

  /* ---------------------------------------------------------------------
     2. LE TITRE DE L'ONGLET
     Il alterne pendant une minute — le temps de se faire remarquer dans
     une barre d'onglets — puis se fige sur le rappel. Une alternance qui
     ne s'arrete jamais finit par ressembler a une publicite clignotante.
     --------------------------------------------------------------------- */
  var swapTimer = null;
  var swapStop = null;
  var swapOn = false;

  function titleStart() {
    if (root.dataset.title !== 'on' || swapTimer || !count()) return;
    var message = root.dataset.titleText || '';
    if (!message) return;
    titleOriginal = document.title;
    document.title = message;
    swapOn = true;
    swapTimer = window.setInterval(function () {
      swapOn = !swapOn;
      document.title = swapOn ? message : titleOriginal;
    }, 1600);
    swapStop = window.setTimeout(function () {
      window.clearInterval(swapTimer);
      swapTimer = null;
      document.title = message;
    }, 60000);
  }

  function titleReset() {
    if (swapTimer) { window.clearInterval(swapTimer); swapTimer = null; }
    if (swapStop) { window.clearTimeout(swapStop); swapStop = null; }
    document.title = titleOriginal;
  }

  /* ---------------------------------------------------------------------
     MESURER L'ABSENCE — LE POULS
     Premiere version : on notait l'heure de depart sur « visibilitychange ».
     Elle ne pouvait pas marcher. Le navigateur emet aussi cet evenement au
     moment ou il decharge une page : passer de l'accueil a une fiche produit
     ecrivait donc un depart. L'absence mesuree retombait a zero a chaque
     clic, et le bandeau ne sortait jamais pour personne.

     Ici, l'onglet visible bat toutes les 30 secondes. Le battement s'arrete
     des qu'il passe en arriere-plan, et ne reprend qu'au retour. L'absence,
     c'est l'ecart entre le dernier battement et maintenant : elle vaut
     autant pour l'onglet laisse ouvert que pour la boutique fermee hier
     soir et rouverte ce matin.
     --------------------------------------------------------------------- */
  var HEARTBEAT = 30000;
  var beat = null;
  var gap = 0; // minutes

  function touch() { save({ seen: now() }); }
  function measure() {
    var seen = state().seen;
    gap = seen ? (now() - seen) / 60000 : 0;
  }
  function beatStart() { if (!beat) beat = window.setInterval(touch, HEARTBEAT); }
  function beatStop() { if (beat) { window.clearInterval(beat); beat = null; } }

  measure(); // avant le premier battement, sinon on efface ce qu'on mesure
  touch();
  if (!document.hidden) beatStart();

  document.addEventListener('visibilitychange', function () {
    if (document.hidden) {
      beatStop();
      titleStart();
    } else {
      measure();
      touch();
      beatStart();
      titleReset();
      maybeBanner();
    }
  });

  /* ---------------------------------------------------------------------
     3. LE BANDEAU DE RETOUR
     Il n'apparait qu'apres une absence reelle, une seule fois par panier,
     et jamais dans le tunnel de commande.
     --------------------------------------------------------------------- */
  var banner = root.querySelector('[data-recovery-banner]');

  function signature() {
    return count() + ':' + (root.dataset.total || '0');
  }

  function maybeBanner() {
    if (!banner || root.dataset.banner !== 'on') return;
    if (!count()) return;
    if (document.querySelector('z-cart-drawer[open]')) return;

    if (gap < parseFloat(root.dataset.bannerAfter || '30')) return;
    if (state().hidFor === signature()) return;

    banner.hidden = false;
    // Le retrait de [hidden] et l'ajout de la classe doivent tomber sur deux
    // images successives, sinon la transition d'entree ne joue pas.
    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () { banner.classList.add('is-in'); });
    });
    if (Z && Z.announce) Z.announce(banner.dataset.announce || '');
  }

  function hideBanner(remember) {
    if (!banner) return;
    banner.classList.remove('is-in');
    window.setTimeout(function () { banner.hidden = true; }, 260);
    if (remember) save({ hidFor: signature() });
  }

  if (banner) {
    banner.addEventListener('click', function (event) {
      if (event.target.closest('[data-recovery-close]')) {
        hideBanner(true);
        return;
      }
      if (event.target.closest('[data-recovery-open]')) {
        event.preventDefault();
        hideBanner(true);
        var drawer = document.querySelector('z-cart-drawer');
        if (drawer && typeof drawer.open === 'function') drawer.open();
        else window.location.href = (Z && Z.routes ? Z.routes.cart : '/cart');
      }
    });
  }

  // Un panier qui change repart de zero : le bandeau redevient legitime.
  if (Z && Z.on) {
    Z.on('cart:updated', function () {
      save({ hidFor: null });
    });
  }

  // Retour par l'historique (page restauree depuis le cache) : la visite
  // precedente compte comme un depart, sans quoi le bandeau ne sort jamais
  // pour ceux qui reviennent par le bouton « precedent ».
  window.addEventListener('pageshow', function (event) {
    if (!event.persisted) return;
    measure();
    touch();
    maybeBanner();
  });

  maybeBanner();
})();
